import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-comment-dialog',
  templateUrl: './add-comment-dialog.component.html',
  styleUrls: ['./add-comment-dialog.component.css']
})
export class AddCommentDialogComponent {
  comment:string=null;
  rating = 0;
  stars = Array(5).fill(0);

  public constructor(public dialogRef:MatDialogRef<AddCommentDialogComponent>)
  {}

  rate(selectedRating: number) {
     if(selectedRating!=this.rating)
      this.rating = selectedRating;
  }

  save()
  {
    if(this.rating!=0 && (this.comment!=null || this.comment!="" ))
    {
      var data={
        Rating: this.rating,
        Comment: this.comment,
        Status:true
      }
    }
    this.dialogRef.close(data);
  }
}
